module.exports = __webpack_public_path__ + "img/success-modal.cdf27381.png";